import Styles from "./KeyPad.module.scss";
import classnames from "classnames";
import { ReactComponent as CallIcon } from "../../../../icons/extra_icons/call.svg"
import { ReactComponent as AsteriksIcon } from "../../../../icons/extra_icons/asterisk.svg"
import { ReactComponent as BackSpaceIcon } from "../../../../icons/extra_icons/backspace.svg"
import { ReactComponent as VideoIcon } from "../../../../icons/extra_icons/videocall.svg"
import { useState } from "react";

// @ts-ignore  
import audio_1 from "../../../../res/audio/keypad/audio_1.wav"
// @ts-ignore  
import audio_2 from "../../../../res/audio/keypad/audio_2.wav"
// @ts-ignore  
import audio_3 from "../../../../res/audio/keypad/audio_3.wav"

interface KeyPadProps {
    number: string;
    onClickKeypad: (data: string) => void;
}

const KeyPad = ({ number, onClickKeypad }: KeyPadProps) => {
    let keyPadSound1 = new Audio(audio_1)
    let keyPadSound2 = new Audio(audio_2)
    let keyPadSound3 = new Audio(audio_3)

    const keyPadOption = [
        {
            label: 1,
            value: "1",
            subLabel: "0_0"
        },
        {
            label: 2,
            value: "2",
            subLabel: "ABC"
        },
        {
            label: 3,
            value: "3",
            subLabel: "DEF"
        },
        {
            label: 4,
            value: "4",
            subLabel: "GHI"
        },
        {
            label: 5,
            value: "5",
            subLabel: "JKL"
        },
        {
            label: 6,
            value: "6",
            subLabel: "MNO"
        },
        {
            label: 7,
            value: "7",
            subLabel: "PQRS"
        },
        {
            label: 8,
            value: "8",
            subLabel: "TUV"
        },
        {
            label: 9,
            value: "9",
            subLabel: "WXYZ"
        },
        {
            label: <AsteriksIcon />,
            value: "*",
            subLabel: ""
        },
        {
            label: 0,
            value: "0",
            subLabel: "+"
        },
        {
            label: "#",
            value: "#",
            subLabel: ""
        }
    ]


    const handleDoubleClick = (e: any, value: string) => {
        value === "+" && onClickKeypad(number.slice(0, -2) + value)
    }

    const handleCalling = () => {
        window.location.href="tel:"+number
    }

    const handleBackSpace = () => {
        onClickKeypad(number.substring(0, number.length - 1))
    }

    const handleSingleClick = (index: number, value: string) => {
        if (index % 3 === 1) {
            keyPadSound1.play()
        }
        else if (index % 3 === 2) {
            keyPadSound2.play()
        }
        else {
            keyPadSound3.play()
        }
        onClickKeypad(number + value)
    }
    return (
        <div className={Styles.container}>
            <div className={Styles.number_display}>
                {number}
            </div>
            <div className={Styles.keypad_container}>
                {
                    keyPadOption.map((key: any, index: number) => {
                        return (
                            <div key={key.label} className={Styles.key_container} onClick={() => { handleSingleClick(index + 1, key.value) }} onDoubleClick={(e: any) => { handleDoubleClick(e, key.subLabel) }}>
                                <div className={Styles.label}>{key.label}</div>
                                <div className={Styles.sub_label}>{key.subLabel}</div>
                            </div>
                        )
                    })
                }
            </div>
            <div className={Styles.bottom_icon_container}>
                {
                   number  && (
                        <div className={Styles.icon}>
                    <VideoIcon />
                </div>
                     )
                }
                <div className={classnames(Styles.icon)}>
                    <div className={Styles.phone} onClick={handleCalling}>
                    <CallIcon />
                    </div>
                </div>
                {
                   number  && (
                        <div className={Styles.icon} onClick={handleBackSpace}>
                    <BackSpaceIcon />
                </div>
                     )
                }
            </div>
        </div>
    )

}


export default KeyPad
